import React from 'react'
import {isHeadless} from '../../../../../../commons/selectors/environment'
import {useAppSelector} from '../../../hooks/runtime'
import {BackToSiteButton} from '../../common/back-to-site-button'
import {RegistrationButtonSkin} from '../../registration-buttons/registration-button-skin'
import {Container} from '../common/container'
import {Subtitle} from '../common/subtitle'
import {Title} from '../common/title'
import {OrderCanceledProps} from './interfaces'

export const OrderCanceled = ({t, navigateToDetails}: OrderCanceledProps) => {
  const headless = useAppSelector(isHeadless)

  return (
    <Container dataHook="order-canceled">
      <div style={{textAlign: 'center'}}>
        <Title text={t('paymentError.paymentCanceledTitle')} />
        <Subtitle lines={[t('paymentError.paymentCanceledDescription')]} />
        {headless ? (
          <BackToSiteButton text={t('paymentError.buttonText')} />
        ) : (
          <RegistrationButtonSkin text={t('paymentError.buttonText')} onClick={() => navigateToDetails()} />
        )}
      </div>
    </Container>
  )
}
